module.exports = __webpack_public_path__ + "media/country_flags/cy-99f4e27f.png";